export default class MenuAvailability {
    id?: number;
    dayOfWeek?: number;
    startTime?: string;
    endTime?: string;
    menuId!: number;

    static fromJson(json: any) {
        const availability = new MenuAvailability();
        availability.id = json.id;
        availability.dayOfWeek = json.dayOfWeek;
        availability.startTime = json.startTime;
        availability.endTime = json.endTime;
        availability.menuId = json.menuId;
        return availability;
    }
}